import { render } from "./currency-modal-trigger.vue?vue&type=template&id=9baadc88"
import script from "./currency-modal-trigger.vue?vue&type=script&lang=js"
export * from "./currency-modal-trigger.vue?vue&type=script&lang=js"

import "./currency-modal-trigger.vue?vue&type=style&index=0&id=9baadc88&lang=scss"

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__